<template>
<v-card>
  <v-card-text>
    <v-row>
      <v-col cols="12" md="3">
        <v-text-field label="نام کاربر" v-model="full_name"></v-text-field>
        <v-text-field label="شماره تلفن" v-model="phone_number"></v-text-field>
        <v-text-field label="کد ملی" v-model="national_code"></v-text-field>
        <v-select label="مقطع تحصیلی" clearable :items="garde_numbers" v-model="grade" item-value="value" item-text="name"></v-select>
        <v-select label="شهر" clearable :items="states" v-model="city" item-value="value" item-text="name"></v-select>
        <v-select :return-object="false" label="دوره فیلم"  :items="movie_years" v-model="movie_year" item-value="value" item-text="text" multiple chips></v-select>
        <v-select label="دوره گرافیک" :return-object="false" multiple  :items="graphic_years" v-model="graphic_year" item-value="value" item-text="text" chips></v-select>
      </v-col>
    </v-row>
  </v-card-text>
  <v-card-actions>
    <v-btn color="primary" @click="$store.dispatch('filter_users')">فیلتر</v-btn>
    <v-btn color="primary" @click="$store.dispatch('copy_filters_users_to_clipboard')">کپی کردن فیلتر</v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
import static_config from "@/components/common/Statics";
import {mapState} from "vuex";

export default {
  name: "UserListFilterCard",
  data:()=>{
    return {
      garde_numbers: static_config.grade_numbers,
      states: static_config.states_cities(),
      movie_years : static_config.movie_years,
      graphic_years: static_config.graphic_years
    }
  },
  computed :{
    ...mapState({
      filterable_selects: state => state.Admin.admin.user_list.filter.filterable_selects,
      filterable_tags: state => state.Admin.admin.user_list.filter.filterable_tags,
      categories: state => state.Submit.categories_all,
      statuses: state => state.Submit.statuses,
      states: state => state.Submit.states,
      tags: state => state.Admin.admin.user_list.filter.filterable_tags,

    }),
    full_name :{
      get(){
        return this.$store.state.Admin.admin.user_list.filter.full_name
      },
      set(value){
        this.$store.commit('set_admin_user_list_search_full_name', value)
      }
    },
    phone_number :{
      get(){
        return this.$store.state.Admin.admin.user_list.filter.phone_number
      },
      set(value){
        this.$store.commit('set_admin_user_list_phone_number', value)
      }
    },
    national_code :{
      get(){
        return this.$store.state.Admin.admin.user_list.filter.national_code
      },
      set(value){
        this.$store.commit('set_admin_user_list_national_code', value)
      }
    },
    grade :{
      get(){
        return this.$store.state.Admin.admin.user_list.filter.grade
      },
      set(value){
        this.$store.commit('set_admin_user_list_grade', value)
      }
    },
    city :{
      get(){
        return this.$store.state.Admin.admin.user_list.filter.city
      },
      set(value){
        this.$store.commit('set_admin_user_list_city', value)
      }
    },
    movie_year :{
      get(){
        return this.$store.state.Admin.admin.user_list.filter.movie_year
      },
      set(value){
        this.$store.commit('set_admin_user_list_movie_year', value)
      }
    },
    graphic_year :{
      get(){
        return this.$store.state.Admin.admin.user_list.filter.graphic_year
      },
      set(value){
        this.$store.commit('set_admin_user_list_graphic_year', value)
      }
    },
  },
}
</script>

<style scoped>

</style>